import React from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function TermsAndConditions() {
    return (
        <div>
            <SEO
                title="Terms and Conditions - Smart Life Choice"
                description="Read the terms and conditions for using Smart Life Choice. Understand your rights and responsibilities when accessing our health and fitness content."
                url="/terms-conditions"
                keywords="terms and conditions, user agreement, website terms, legal terms, usage policy"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="policy-section" style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        padding: '2rem 1rem'
                    }}>
                        <h1 style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            marginBottom: '1rem',
                            color: 'var(--color-primary)'
                        }}>Terms and Conditions</h1>

                        <div style={{
                            fontSize: '0.95rem',
                            color: 'var(--color-gray-600)',
                            marginBottom: '2rem',
                            paddingBottom: '1rem',
                            borderBottom: '2px solid var(--color-gray-200)'
                        }}>
                            <p><strong>Effective Date:</strong> 10 November 2025</p>
                        </div>

                        <div style={{
                            lineHeight: '1.8',
                            fontSize: '1.05rem',
                            color: 'var(--color-gray-800)'
                        }}>
                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>1. Acceptance of Terms</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                By accessing or using Smart Life Choice, you agree to comply with and be bound by these Terms and Conditions.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>2. Use of Content</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                All articles, images, and media on this website are owned by Smart Life Choice unless otherwise stated.
                                You may share our content with proper credit, but you may not copy, republish, or redistribute our content
                                without written permission.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>3. Health and Fitness Disclaimer</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                All content on this site is provided for educational and informational purposes only.
                                We are not licensed medical professionals. Always consult a qualified healthcare provider
                                before starting any diet, supplement, or fitness program.
                            </p>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Smart Life Choice and its authors are not responsible for any health consequences resulting
                                from the use or misuse of our information.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>4. External Links</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Our website may include links to third-party sites, products, or services.
                                We are not responsible for the content, accuracy, or practices of external websites.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>5. Affiliate Disclosure</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Some links on this website may be affiliate links, meaning we earn a small commission
                                if you make a purchase at no additional cost to you.
                                This helps us maintain and grow Smart Life Choice.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>6. Limitation of Liability</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                We are not liable for any damages, injuries, or losses arising from your use of our website
                                or reliance on any information provided.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>7. Governing Law</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                These Terms are governed by and interpreted in accordance with the laws of the United Kingdom.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>8. Contact</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                For questions about these Terms, please contact us at:{' '}
                                <a href="mailto:smartlifechoiceuk@gmail.com" style={{
                                    color: 'var(--color-primary)',
                                    textDecoration: 'underline'
                                }}>smartlifechoiceuk@gmail.com </a>
                            </p>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default TermsAndConditions;
